import * as React from 'react';

import { CarouselLayout } from '../CarouselLayout';
import { CarouselPhoto } from '../CarouselPhoto';
import { CarouselTour } from '../CarouselTour';
import { EMediaType, IGallerySlide } from '../../../../types/project';

interface ICarouselItemProps {
  slide: IGallerySlide;
  lazy: boolean;
}

export const CarouselItem = React.memo(({ slide, lazy }: ICarouselItemProps) => {
  const { type, thumb } = slide;

  switch (type) {
    case EMediaType.Photo:
      return <CarouselPhoto src={thumb} lazy={lazy} />;
    case EMediaType.Layout:
      return <CarouselLayout src={thumb} />;
    case EMediaType.Tour:
      return <CarouselTour src={thumb} />;
    default:
      return null;
  }
});

CarouselItem.displayName = 'CarouselItem';
